import React, {useState} from "react";

import {useQuery} from "react-query";
import {i18n} from "translate/i18n";
import {toast} from "react-toastify";

import Page from "components/Page";
import PaginationTable from "components/Pagination";
import {Tooltip} from "../../components/Tooltip";
import {getContent} from "services/Content.service";
import {useNavigate, Outlet, useParams} from "react-router";
import {useUser} from "../../store/providers/app";

const Contents = () => {

    const navigate = useNavigate()
    const {id} = useParams()

    const {user} = useUser()

    const [newContent, setNewContent] = useState(null)
    const [contents, setContents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginate, setPaginate] = useState([]);
    const [selected, setSelected] = useState('');

    const {isFetching} = useQuery(['contents', currentPage, selected],
        () => {
            return getContent(selected, true, currentPage)
        }, {
            onSuccess: (res) => {

                if(res) {
                    const {data} = res;

                    setPaginate({
                        total: data.total,
                        from: data.from,
                        to: data.to
                    })

                    setContents(data.data)
                }
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'))
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true
        }
    )

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    const handleEdit = (id) => {
        navigate(`/content/edit/${id}`)
    }

    const handleAdd = () => {
        setNewContent('new')
        navigate(`/content/add`)
    }

    if (user.profile !== 1) {
        toast.error('Você não tem permissão para acessar esta área!');
        navigate('/')
    }

    return (
        <Page label={i18n.t('titlePage.content')} icon="bi bi-pencil-square">

            {id || newContent ? <Outlet /> :

            <div className="row mt-3">
                <div className="col-12">
                    <div className="card border-0 shadow-sm p-0">
                        <div className="card-header">
                            <div className="row justify-content-end">
                                <div className="col-12 py-3">
                                    <button className="btn btn-outline-success px-5 py-2 float-end bi-plus" onClick={() => handleAdd()}>Adicionar</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                            <table className="table table-hover mb-0 align-middle">
                                <thead className="bg-primary text-uppercase text-sm">
                                    <tr>
                                        <th />
                                        <th className="py-4">Varid</th>
                                        <th className="py-4">{i18n.t('label.group')}</th>
                                        <th className="py-4">PT</th>
                                        <th className="py-4">EN</th>
                                        <th />
                                    </tr>
                                </thead>

                                { !contents?.length &&
                                    <tbody>
                                        <tr>
                                            <td colSpan={6}>{i18n.t('upload.tableRecords')}</td>
                                        </tr>
                                    </tbody>
                                }

                                <tbody>
                                {contents.map((content, index) => (
                                    <React.Fragment key={index}>
                                    <tr key={index} >
                                        <td>
                                            <Tooltip label={i18n.t('buttons.more')}>
                                                <button className="btn btn-primary btn-sm" type="button"
                                                        data-bs-toggle="collapse" data-bs-target={`#collapse${index}`} aria-expanded="true" aria-controls={`collapse${index}`}>
                                                    <i className="bi bi-plus" />
                                                </button>
                                            </Tooltip>
                                        </td>
                                        <td className="text-muted">{content.varid}</td>
                                        <td className="fw-bolder">{content.group}</td>
                                        <td className="ellipsis pt-4"><span dangerouslySetInnerHTML={{__html: content.content_pt }} /></td>
                                        <td className="ellipsis pt-4"><span dangerouslySetInnerHTML={{__html: content.content_en }} /></td>
                                        <td className="text-end">
                                            <Tooltip label={i18n.t('buttons.edit')}>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm bi-pencil"
                                                    onClick={() => handleEdit(content.id)}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                        <tr className="border-top-0">
                                            <td colSpan={6} className="p-0">
                                                <div id={`collapse${index}`} className="accordion-collapse collapse"
                                                     aria-labelledby="headingOne" data-bs-parent={`#collapse${index}`}>
                                                    <div className="accordion-body table-responsive p-4">

                                                        <div>
                                                            <h5>PT</h5>
                                                            <span dangerouslySetInnerHTML={{__html: content.content_pt }}/>
                                                        </div>

                                                        <hr />

                                                        <div>
                                                            <h5>EN</h5>
                                                            <span dangerouslySetInnerHTML={{__html: content.content_en }}/>
                                                        </div>

                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="card-footer border-top-0 bg-white">
                            <PaginationTable
                                isFetching={isFetching}
                                paginate={paginate}
                                handlePageClick={handlePageClick}
                            />
                        </div>
                    </div>
                </div>
            </div>

         }
        </Page>
    )
}

export default Contents
